<template>
    <SideBar v-if="showGlobalComponent" />
    <NavBar v-if="showGlobalComponent" />
    <LoadingPage />
    <router-view />
</template>


<script>
import { mapActions, mapGetters } from 'vuex';
// import { startDevToolsDetector } from '@/utilities/useDevToolsDetector';

export default {
    data() {
        return {
            devtoolsInterval: null
        }
    },
    async mounted() {

    },
    computed: {
        showGlobalComponent() {
            // Ocultar el componente en rutas
            return (this.$route.name !== 'login' && this.$route.name !== 'NotFound');
        }
    },
    created() {
        this.setupActivityListeners();
        if (this.isAuthenticated()) {
            this.resetLogoutTimer();
        }
    },
    methods: {
        ...mapGetters(['isAuthenticated']),
        ...mapActions(['resetLogoutTimer', 'logout']),
        async setupActivityListeners() {

            const events = ['mousemove', 'keydown', 'click', 'scroll'];
            events.forEach(event => {
                window.addEventListener(event, this.handleUserActivity);
            });
        },
        handleUserActivity() {
            if (this.$route.name !== 'login') {
                return this.resetLogoutTimer();
            }
            return true
        }
    },
    beforeUnmount() {
        const events = ['mousemove', 'keydown', 'click', 'scroll'];
        events.forEach(event => {
            window.removeEventListener(event, this.handleUserActivity);
        });

        if (this.devtoolsInterval) {
            clearInterval(this.devtoolsInterval)
        }
    }
}

</script>
